import { cn } from '@/lib/utils';
import Image from 'next/image';
import styles from './badge.module.scss';

export const Badge = ({ text, className }: { text: string; className?: string }) => {
  return (
    <div className={cn(styles.component, className)}>
      <Image src="/images/dot.svg" alt="Badge Dot" width={8} height={8} />
      <span className={styles.component_text}>{text.toUpperCase()}</span>
    </div>
  );
};
